import Resposta from './Resposta';

export default Resposta;
